import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDistributorStock = (id, page = 1, term = '') => useQuery({ queryKey: [`distributor-stock`, id, page, term], queryFn: async () => {
    if(!id) return null
    const callback = await API.get(`/distributors/${id}/stock?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}})

export default useDistributorStock